import { useQuery } from '@tanstack/react-query';

import { useEffectiveUserId } from '../../adminRewrite/impersonation/useEffectiveUserId';
import { getPages } from '../api/build-a-dash-api';
import type { Page } from '../components/PageConfigProvider/types';

export const pageQueryKeys = {
  all: ['pages'] as const,
  lists: (userId?: string) =>
    [...pageQueryKeys.all, 'list', userId ?? 'self'] as const,
  details: () => [...pageQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...pageQueryKeys.details(), id] as const,
} as const;

export function usePagesQuery() {
  const userId = useEffectiveUserId();
  return useQuery<Page[]>({
    queryKey: pageQueryKeys.lists(userId),
    queryFn: () => getPages(userId),
    enabled: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
